import { Scrn, Box, Ln, Bar, Ring, GradBtn, ChipRow, Tick } from "./atoms";

export const WorkoutScreen = () => (
    <Scrn title="Workout" badge="Week 3 · Day 2">
        <ChipRow items={["M", "T", "W", "T", "F", "S", "S"]} active={1} />
        <Box className="border-[#3fcbf3]/20">
            <p className="text-[9px] font-extrabold uppercase tracking-widest text-[#3fcbf3]">Today</p>
            <p className="mt-0.5 text-[12px] font-extrabold text-white">Upper Body Strength</p>
            <p className="text-[8px] text-[#7d8da3]">4 exercises · ~45 min · Goal: build muscle</p>
        </Box>
        {[
            ["Bench Press", "4 × 8 · Rest 90s"],
            ["Bent-Over Row", "4 × 10 · Rest 90s"],
            ["Overhead Press", "3 × 12 · Rest 60s"],
        ].map(([n, d], i) => (
            <Box key={n} className="flex items-center gap-2">
                <span className="text-[10px] font-extrabold text-[#f0356f]">0{i + 1}</span>
                <div className="flex-1">
                    <p className="text-[10px] font-bold text-white">{n}</p>
                    <p className="text-[8px] text-[#7d8da3]">{d}</p>
                </div>
            </Box>
        ))}
        <GradBtn>Start Workout</GradBtn>
    </Scrn>
);

export const NutritionScreen = () => (
    <Scrn title="Nutrition" badge="Today">
        <Box className="flex items-center gap-3">
            <Ring pct={0.72} label="2,026" sub="kcal" />
            <div className="flex-1 space-y-1.5">
                {[["Protein 130g", "78%", "#3fcbf3"], ["Carbs 205g", "62%", "#ffffff"], ["Fats 68g", "55%", "#f0356f"]].map(([n, w, c]) => (
                    <div key={n}>
                        <p className="mb-0.5 text-[8px] font-bold uppercase tracking-widest text-[#7d8da3]">{n}</p>
                        <Bar w={w} c={c} />
                    </div>
                ))}
            </div>
        </Box>
        {[
            ["Breakfast", "Paneer Oats Bowl", "420 kcal"],
            ["Lunch", "Chicken Rice Plate", "640 kcal"],
        ].map(([m, n, k]) => (
            <Box key={m} className="flex items-center justify-between">
                <div>
                    <p className="text-[8px] font-bold uppercase tracking-widest text-[#3fcbf3]">{m}</p>
                    <p className="text-[10px] font-bold text-white">{n}</p>
                </div>
                <span className="text-[9px] font-bold text-[#7d8da3]">{k}</span>
            </Box>
        ))}
    </Scrn>
);

export const AiCoachScreen = () => (
    <Scrn title="AI Coach" badge="Online">
        <div className="max-w-[85%] self-end rounded-xl rounded-br-sm bg-[#f0356f]/15 border border-[#f0356f]/25 p-2">
            <p className="text-[9px] text-white">Can I swap today's squats? My knee feels off.</p>
        </div>
        <div className="max-w-[88%] self-start rounded-xl rounded-bl-sm border border-[#3fcbf3]/25 bg-[#3fcbf3]/10 p-2">
            <p className="mb-0.5 text-[7px] font-extrabold uppercase tracking-widest text-[#3fcbf3]">SHREDxpro Coach</p>
            <p className="text-[9px] leading-relaxed text-white">
                Yes — try the leg press instead. Same movement pattern, less shear on the knee. I've
                adjusted today's plan.
            </p>
        </div>
        <div className="max-w-[85%] self-end rounded-xl rounded-br-sm bg-[#f0356f]/15 border border-[#f0356f]/25 p-2">
            <p className="text-[9px] text-white">And my protein target on rest days?</p>
        </div>
        <div className="mt-auto space-y-1.5">
            <ChipRow items={["Adjust my calories", "Deload week?", "Plateau help"]} active={-1} />
            <Box className="flex items-center justify-between !p-2">
                <Ln w="w-1/2" />
                <span className="flex h-5 w-5 items-center justify-center rounded-full text-[9px] font-black text-[#07101c]" style={{ background: "linear-gradient(92deg,#45d1f5,#f0356f)" }}>↑</span>
            </Box>
        </div>
    </Scrn>
);

export const ExerciseSwapScreen = () => (
    <Scrn title="Swap Exercise" badge="Smart Swap">
        <Box className="border-[#f0356f]/25">
            <p className="text-[8px] font-bold uppercase tracking-widest text-[#7d8da3]">Current</p>
            <p className="text-[12px] font-extrabold text-white">Bench Press</p>
            <p className="text-[8px] text-[#7d8da3]">4 × 8 · Barbell · Chest focus</p>
        </Box>
        <div className="flex justify-center text-[#3fcbf3]">
            <span className="rounded-full border border-[#3fcbf3]/40 bg-[#3fcbf3]/10 px-3 py-0.5 text-[8px] font-extrabold uppercase tracking-widest">↓ Swap</span>
        </div>
        {[
            ["Dumbbell Bench Press", "Same pattern · no spotter needed"],
            ["Machine Chest Press", "Same pattern · guided path"],
            ["Smith Machine Press", "Same pattern · stable bar"],
        ].map(([n, d]) => (
            <Box key={n} className="flex items-center gap-2">
                <div className="flex-1">
                    <p className="text-[10px] font-bold text-white">{n}</p>
                    <p className="text-[8px] text-[#3fcbf3]">{d}</p>
                </div>
                <Tick done={false} />
            </Box>
        ))}
    </Scrn>
);

export const FoodSwapScreen = () => (
    <Scrn title="Swap Food" badge="Macro Matched">
        <Box className="border-[#f0356f]/25">
            <p className="text-[8px] font-bold uppercase tracking-widest text-[#7d8da3]">In your lunch</p>
            <p className="text-[12px] font-extrabold text-white">Chicken Breast · 150g</p>
            <p className="text-[8px] text-[#7d8da3]">248 kcal · 46g protein</p>
        </Box>
        <div className="flex justify-center text-[#3fcbf3]">
            <span className="rounded-full border border-[#3fcbf3]/40 bg-[#3fcbf3]/10 px-3 py-0.5 text-[8px] font-extrabold uppercase tracking-widest">↓ Swap</span>
        </div>
        {[
            ["Paneer · 120g", "Vegetarian · ≈ macros"],
            ["Boiled Eggs × 3", "Eggetarian · ≈ macros"],
            ["Tofu · 180g", "Vegan · ≈ macros"],
        ].map(([n, d]) => (
            <Box key={n} className="flex items-center gap-2">
                <div className="flex-1">
                    <p className="text-[10px] font-bold text-white">{n}</p>
                    <p className="text-[8px] text-[#3fcbf3]">{d}</p>
                </div>
                <Tick done={false} />
            </Box>
        ))}
    </Scrn>
);
